import { formatMultipleSortingForEndpoint } from '@app/components/data-table/lib/parsers';
import Page from '@app/components/layout/page/page';
import { ingredientFilters } from '@app/components/tables/ingredients-table/filters';
import IngredientsTable from '@app/components/tables/ingredients-table/ingredients-list-table';
import { useDataTableQueryState } from '@app/hooks/use-data-table-query-state';
import { useGetIngredients } from '@shared/api/hooks/pcf/ingredients';
import { IngredientsListParams } from '@shared/api/types';
import { parseAsString, useQueryState } from 'nuqs';

export default function IngredientsListPage() {
  const { page, perPage, sort, ...filterStates } = useDataTableQueryState({
    filters: Object.values(ingredientFilters).map(({ column }) => column),
  });
  const [name] = useQueryState('name', parseAsString);

  const params: IngredientsListParams = {
    page: page,
    page_size: perPage,
    search: name || '',
    emissionsCategory: filterStates['emissionsCategory'],
    sort: formatMultipleSortingForEndpoint(sort! || []),
  };

  Object.values(ingredientFilters).forEach(({ apiKey, column }) => {
    params[apiKey] = filterStates[column];
  });

  const data = useGetIngredients(params);

  return (
    <Page name="Ingredients" page="subpage">
      <IngredientsTable {...data} />
    </Page>
  );
}
